<div *ngIf="tableType === 'bigSize'" class="card-table">
  <table mat-table [dataSource]="data" class="tb-skeleton tb-skMain">
    <!-- Implicit Column -->
    <ng-container matColumnDef="$implicit">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let data">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Index Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let index = index">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Count Column -->
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let count = count">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- First Column -->
    <ng-container matColumnDef="first">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let first = first">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Last Column -->
    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let last = last">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Even Column -->
    <ng-container matColumnDef="even">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let even = even">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Odd Column -->
    <ng-container matColumnDef="odd">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let odd = odd">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<div *ngIf="tableType === 'smallSize'">
  <table mat-table [dataSource]="dataSmall" class="tb-skeleton tb-skMain">
    <!-- Implicit Column -->
    <ng-container matColumnDef="$implicit">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let data">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Index Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let index = index">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Count Column -->
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let count = count">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- First Column -->
    <ng-container matColumnDef="first">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let first = first">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Last Column -->
    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let last = last">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Even Column -->
    <ng-container matColumnDef="even">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let even = even">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Odd Column -->
    <ng-container matColumnDef="odd">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let odd = odd">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsSmall"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsSmall"></tr>
  </table>
</div>

<div *ngIf="tableType === 'listSo'" class="card-table">
  <table mat-table [dataSource]="dataSmall" class="tb-skeleton tb-skMain">
    <!-- Implicit Column -->
    <ng-container matColumnDef="$implicit">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-circle" style="--c-s: 50px; margin-left: auto; margin-right: auto"></div>
      </th>
      <td style="width: 50px" mat-cell *matCellDef="let data">
        <div class="skeleton skeleton-circle" style="--c-s: 50px; margin-left: auto; margin-right: auto"></div>
      </td>
    </ng-container>

    <!-- Index Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px; margin-right: 20px"></div>
      </th>
      <td mat-cell *matCellDef="let index = index">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px; margin-right: 20px"></div>
      </td>
    </ng-container>

    <!-- Count Column -->
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let count = count">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- another Column -->
    <ng-container matColumnDef="another">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let count = count">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- First Column -->
    <ng-container matColumnDef="first">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let first = first">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Last Column -->
    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let last = last">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Even Column -->
    <ng-container matColumnDef="even">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </th>
      <td mat-cell *matCellDef="let even = even">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 185px"></div>
      </td>
    </ng-container>

    <!-- Odd Column -->
    <ng-container matColumnDef="odd">
      <th mat-header-cell *matHeaderCellDef>
        <ngx-skeleton-loader
          appearance="circle"
          count="4"
          [theme]="{
            width: '40px',
            'border-radius': '5px',
            height: '40px',
            margin: '15px 0 10px 5px'
          }"
        ></ngx-skeleton-loader>
      </th>
      <td mat-cell *matCellDef="let odd = odd">
        <ngx-skeleton-loader
          appearance="circle"
          count="4"
          [theme]="{
            width: '40px',
            'border-radius': '5px',
            height: '40px',
            margin: '15px 0 10px 5px'
          }"
        ></ngx-skeleton-loader>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsListSo"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsListSo"></tr>
  </table>
</div>

<div *ngIf="tableType === 'xsSize'">
  <table mat-table [dataSource]="dataSmall" class="tb-skeleton tb-skMain">
    <!-- Implicit Column -->
    <ng-container matColumnDef="$implicit">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let data">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Index Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let index = index">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Count Column -->
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let count = count">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- First Column -->
    <ng-container matColumnDef="first">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let first = first">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Last Column -->
    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let last = last">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Even Column -->
    <ng-container matColumnDef="even">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let even = even">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Odd Column -->
    <ng-container matColumnDef="odd">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let odd = odd">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsSmall"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsSmall"></tr>
  </table>
</div>

<div *ngIf="tableType === 'salesGPClosed'">
  <table mat-table [dataSource]="dataExtraSmall" class="tb-skeleton tb-skMain">
    <!-- Implicit Column -->
    <ng-container matColumnDef="$implicit">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let data">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Index Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let index = index">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Count Column -->
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let count = count">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- First Column -->
    <ng-container matColumnDef="first">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let first = first">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Last Column -->
    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let last = last">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Even Column -->
    <ng-container matColumnDef="even">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let even = even">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <!-- Odd Column -->
    <ng-container matColumnDef="odd">
      <th mat-header-cell *matHeaderCellDef>
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </th>
      <td mat-cell *matCellDef="let odd = odd">
        <div class="skeleton skeleton-line" style="--lines: 1; --l-gap: 20px; --c-w: 100%"></div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsSmall"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsSmall"></tr>
  </table>
</div>
